/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskChainDTO } from '../models/TaskChainDTO'
import type { TaskDTO } from '../models/TaskDTO'
import type { TaskStatus } from '../models/TaskStatus'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenTasksService {
    /**
     * Create Greenlight Patient Workflow
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createGreenlightPatientWorkflowTasksCreateGreenlightPatientWorkflowPatientIdGet({
        patientId
    }: {
        patientId: string
    }): CancelablePromise<TaskChainDTO | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/tasks/create_greenlight_patient_workflow/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Sync Patient Changes To Snowflake
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static syncPatientChangesToSnowflakeTasksSyncPatientChangesToSnowflakePatientIdGet({
        patientId
    }: {
        patientId: string
    }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/tasks/sync_patient_changes_to_snowflake/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Sync Auth0 Organizations
     * Trigger Auth0 organizations sync task for debugging.
     *
     * This endpoint allows manual triggering of the Auth0 organizations sync
     * task that normally runs on a schedule. It syncs Auth0 organizations
     * containing "aspen" to the aspen.organization_metadata table.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static syncAuth0OrganizationsTasksSyncAuth0OrganizationsPost(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/sync_auth0_organizations'
        })
    }
    /**
     * Export Greenlight Migration Snapshot
     * Trigger the aspen->origin Greenlight migration export (APP-865).
     *
     * Exports the caller's org Greenlight relational rows to JSONL in the S3
     * landing zone at ``greenlight/migration/<org>/``, where origin's migration
     * backfill reads them. Tenant-scoped to the caller's org; runs in-env where
     * aspen's private Postgres is reachable.
     *
     * The write location is derived strictly from ``user.organization_id`` — the
     * endpoint intentionally does NOT accept a ``prefix`` override, so a caller
     * scoped to org A cannot write into another org's snapshot location. (The
     * task keeps an internal ``prefix`` param for tests/internal reuse only.)
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static exportGreenlightMigrationSnapshotTasksExportGreenlightMigrationSnapshotPost(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/export_greenlight_migration_snapshot'
        })
    }
    /**
     * Export Greenlight Documents Snapshot
     * Trigger the aspen->origin Greenlight document-metadata export (APP-865).
     *
     * Exports the caller's org Greenlight document metadata (Snowflake
     * CLINICAL_DOCUMENT / FHIR_DOCUMENT / FHIR_RESOURCE) to JSONL in the S3
     * landing zone at ``greenlight/migration/<org>/``, where origin's document
     * backfill reads it. Tenant-scoped to the caller's org (write prefix derived
     * from ``user.organization_id`` — no caller override); runs in-env where
     * aspen's IP-allowlisted per-org Snowflake is reachable.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static exportGreenlightDocumentsSnapshotTasksExportGreenlightDocumentsSnapshotPost(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/export_greenlight_documents_snapshot'
        })
    }
    /**
     * Export All Greenlight Migration Snapshots
     * Trigger the all-orgs Greenlight migration export (APP-865).
     *
     * System-scoped: enumerates every greenlight org and exports each org's
     * relational + document snapshots to ``greenlight/migration/<org>/``. Unlike
     * the per-org export endpoints (which self-limit to the caller's JWT org),
     * this one ignores the caller's org and touches EVERY org — the most
     * privileged operation in the module — so it is gated on ``admin:aspen``
     * (an internal/ops principal), not merely an authenticated user.
     *
     * ``dry_run`` defaults to **true** (enumerate-only) — returns the org list +
     * patient counts in the task result and writes nothing; run it first to drive
     * the org->connection map, then re-call with ``dry_run=false`` to export.
     * Poll the returned task_id for the result.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static exportAllGreenlightMigrationSnapshotsTasksExportAllGreenlightMigrationSnapshotsPost({
        dryRun = true
    }: {
        dryRun?: boolean
    }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/export_all_greenlight_migration_snapshots',
            query: {
                dry_run: dryRun
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Check Origin Greenlight Connectivity
     * Trigger the aspen->origin Greenlight connectivity readiness probe (APP-110).
     *
     * Runs ``OriginGreenlightClient.check_connectivity`` in the worker (where the
     * ``ORIGIN_GREENLIGHT_*`` config is injected) and returns a task id — poll it
     * for ``{"ok": bool, "error"?}``. ``admin:aspen``-gated: it's an ops/readiness
     * check, not something an arbitrary authenticated user should trigger.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static checkOriginGreenlightConnectivityTasksCheckOriginGreenlightConnectivityPost(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/check_origin_greenlight_connectivity'
        })
    }
    /**
     * Sync All Patients To Snowflake
     * Manually trigger bulk sync of all patients to Snowflake for testing.
     *
     * This endpoint allows manual triggering of the bulk sync task that normally
     * runs daily at 8 AM (12:00 UTC). It will sync all patients with greenlight_id
     * to Snowflake, creating individual sync tasks for each patient.
     *
     * Use this endpoint to test connection pool changes and monitor sync performance.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static syncAllPatientsToSnowflakeTasksSyncAllPatientsToSnowflakeGet(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/tasks/sync_all_patients_to_snowflake'
        })
    }
    /**
     * Sync Auth0 Patient Managers
     * Trigger Auth0 patient managers sync task for debugging.
     *
     * This endpoint allows manual triggering of the Auth0 patient managers sync
     * task that normally runs on a schedule. It syncs Auth0 users with the
     * "Aspen Patient Manager Role" to the aspen.patient_manager table.
     *
     * The task will:
     * 1. Get the "Aspen Patient Manager Role" from Auth0
     * 2. Fetch all organizations from Auth0
     * 3. For each organization, get members with the patient manager role
     * 4. Bulk upsert records in aspen.patient_manager table
     * 5. Deactivate patient managers who are no longer in Auth0 or don't have the role
     *
     * Returns:
     * TaskDTO with task_id for tracking the sync progress
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static syncAuth0PatientManagersTasksSyncAuth0PatientManagersPost(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/sync_auth0_patient_managers'
        })
    }
    /**
     * Sync Patient Documents To S3
     * Trigger sync of patient's Greenlight documents to S3 and Snowflake.
     *
     * This endpoint is an alias for sync_patient_changes_to_snowflake. It triggers
     * the same task which:
     * 1. Fetches clinical documents from Greenlight Health API
     * 2. Uploads them to the api-landing-zone-raw S3 bucket
     * 3. Writes metadata to Snowflake CLINICAL_DOCUMENT table
     *
     * Note: This endpoint uses sync_patient_changes_to_snowflake internally since
     * that task already handles both S3 upload and Snowflake metadata writes.
     *
     * Args:
     * patient_id: The patient's UUID
     *
     * Returns:
     * TaskDTO with task_id for tracking the sync progress
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static syncPatientDocumentsToS3TasksSyncPatientDocumentsToS3PatientIdGet({
        patientId
    }: {
        patientId: string
    }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/tasks/sync_patient_documents_to_s3/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Trigger Backfill Document S3 Uri
     * Queue the APP-659 document_s3_uri backfill on the aspen worker.
     *
     * Backfills NULL document_s3_uri rows in Snowflake CLINICAL_DOCUMENT /
     * FHIR_DOCUMENT left by the MAGRITTE-3767 regression (deferred by PR #3145).
     *
     * Safe by default: dry_run=True resolves and verifies URIs without writing.
     * Re-run with dry_run=False only after reviewing the dry-run task result.
     * Idempotent — only rows with NULL document_s3_uri are ever touched.
     *
     * Args:
     * org_id: Aspen organization_id to backfill (e.g. the Lilly TB-Real org).
     * phase: "clinical" (Phase 1, default), "fhir" (Phase 2), or "all".
     * dry_run: When True (default), write nothing.
     * s3_list_fallback: Resolve URIs from an exhaustive S3 LIST of the org
     * prefix — guarantees URIs point at real objects.
     * limit: Optional cap on candidate rows for staged rollouts.
     *
     * Returns:
     * TaskDTO with task_id for polling GET /aspen/tasks/{task_id}.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static triggerBackfillDocumentS3UriTasksBackfillDocumentS3UriPost({
        orgId,
        phase = 'clinical',
        dryRun = true,
        s3ListFallback = true,
        limit
    }: {
        orgId: string
        phase?: string
        dryRun?: boolean
        s3ListFallback?: boolean
        limit?: number | null
    }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/tasks/backfill_document_s3_uri',
            query: {
                org_id: orgId,
                phase: phase,
                dry_run: dryRun,
                s3_list_fallback: s3ListFallback,
                limit: limit
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Task Status
     * @returns TaskStatus Successful Response
     * @throws ApiError
     */
    public static getTaskStatusTasksTaskIdGet({ taskId }: { taskId: string }): CancelablePromise<TaskStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/tasks/{task_id}',
            path: {
                task_id: taskId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
